module.exports = __webpack_public_path__ + "static/FronPage1-7f1f9621987adb9da0c4216bb5e4a4d6.svg";